import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-brand-green-deep text-brand-cream-light pt-24 pb-12 border-t border-brand-green" data-id="element-39">
      <div className="max-w-7xl mx-auto px-6" data-id="element-40">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16" data-id="element-41">
          {/* Brand Col */}
          <div className="lg:col-span-1" data-id="element-42">
            <Link to="/" className="inline-flex flex-col mb-6" data-id="element-43">
              <span className="font-heading text-3xl font-semibold text-brand-cream-light tracking-wide" data-id="element-44">
                PuttLab
              </span>
              <span className="font-body text-xs tracking-widest text-brand-gold uppercase mt-1" data-id="element-45">
                by TurfsUp!
              </span>
            </Link>
            <p className="text-brand-cream/70 font-body text-sm leading-relaxed max-w-xs" data-id="element-46">
              PuttLab is the experience design division of TurfsUp!, creating
              luxury putting environments and social golf spaces.
            </p>
          </div>

          {/* Links Col 1 */}
          <div data-id="element-47">
            <h4 className="font-heading text-lg mb-6 text-brand-gold" data-id="element-48">
              Expertise
            </h4>
            <ul className="space-y-4 font-body text-sm text-brand-cream/80" data-id="element-49">
              <li data-id="element-50">
                <Link to="/residential" className="hover:text-brand-gold transition-colors" data-id="element-51">
                  Residential
                </Link>
              </li>
              <li data-id="element-52">
                <Link to="/resorts" className="hover:text-brand-gold transition-colors" data-id="element-53">
                  Resorts & Hospitality
                </Link>
              </li>
              <li data-id="element-54">
                <Link to="/developers" className="hover:text-brand-gold transition-colors" data-id="element-55">
                  Developers
                </Link>
              </li>
              <li data-id="element-56">
                <Link to="/activations" className="hover:text-brand-gold transition-colors" data-id="element-57">
                  Activations & Events
                </Link>
              </li>
            </ul>
          </div>

          {/* Links Col 2 */}
          <div data-id="element-58">
            <h4 className="font-heading text-lg mb-6 text-brand-gold" data-id="element-59">
              Explore
            </h4>
            <ul className="space-y-4 font-body text-sm text-brand-cream/80" data-id="element-60">
              <li data-id="element-61">
                <Link to="/concepts" className="hover:text-brand-gold transition-colors" data-id="element-62">
                  Signature Concepts
                </Link>
              </li>
              <li data-id="element-63">
                <Link to="/play" className="hover:text-brand-gold transition-colors" data-id="element-64">
                  PuttLab Play
                </Link>
              </li>
              <li data-id="element-65">
                <Link to="/about" className="hover:text-brand-gold transition-colors" data-id="element-66">
                  About Us
                </Link>
              </li>
              <li data-id="element-67">
                <Link to="/contact" className="hover:text-brand-gold transition-colors" data-id="element-68">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Col */}
          <div data-id="element-69">
            <h4 className="font-heading text-lg mb-6 text-brand-gold" data-id="element-70">
              Connect
            </h4>
            <ul className="space-y-4 font-body text-sm text-brand-cream/80" data-id="element-71">
              <li data-id="element-72">Toronto, ON</li>
              <li data-id="element-73">
                <a href="mailto:hello@puttlabstudio.com" className="hover:text-brand-gold transition-colors" data-id="element-74">
                  hello@puttlabstudio.com
                </a>
              </li>
              <li className="pt-4" data-id="element-75">
                <Link to="/contact" className="inline-block border-b border-brand-gold text-brand-gold pb-1 hover:text-brand-cream-light hover:border-brand-cream-light transition-colors" data-id="element-76">
                  Start a Project
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-brand-green/50 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 text-xs font-body text-brand-cream/50" data-id="element-77">
          <p data-id="element-78">&copy; {currentYear} PuttLab by TurfsUp!. All rights reserved.</p>
          <div className="flex space-x-6" data-id="element-79">
            <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-80">
              Instagram
            </a>
            <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-81">
              LinkedIn
            </a>
            <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-82">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>;
}